import { CombinedGraphQLErrors } from "@apollo/client/errors";
import oryRedirect from "./oryRedirect";

type Options = {
  logout: (tokenError?: boolean) => void;
  oryOrigin: string | undefined;
};

function isTokenError(error: unknown): boolean {
  if (!CombinedGraphQLErrors.is(error)) return false;
  return error.errors.some(
    (e) =>
      e.message &&
      (e.message.includes("API token is expired or revoked") ||
        e.message.includes("API token is invalid or missing") ||
        e.message.includes("Authentication is required to access this field"))
  );
}

function isSessionError(error: unknown): boolean {
  if (!CombinedGraphQLErrors.is(error)) return false;
  return error.errors.some(
    (e) => e.message && e.message.includes("Session is expired or revoked")
  );
}

function is2FAError(error: unknown): boolean {
  if (!CombinedGraphQLErrors.is(error)) return false;
  return error.errors.some((e) => e.extensions?.code === "2FA_REQUIRED");
}

export function isAuthError(error: unknown): boolean {
  return isTokenError(error) || isSessionError(error) || is2FAError(error);
}

// Handles GraphQL errors that mean the user must re-authenticate. Returns
// true when it handled the error and the operation should stop there.
export default function handleAuthError(
  error: unknown,
  { logout, oryOrigin }: Options
): boolean {
  if (!CombinedGraphQLErrors.is(error)) return false;

  if (isTokenError(error)) {
    logout();
    return true;
  }
  if (isSessionError(error)) {
    logout(true);
    return true;
  }
  if (is2FAError(error)) {
    // This is a nice UX only if they've already set up 2FA.
    oryRedirect(
      oryOrigin,
      `/self-service/login/browser?refresh=true&aal=aal2&return_to=${window.location.href}`
    );
    return true;
  }

  return false;
}
